<template>
    <modal id="form-appearance-modal" size="sm" ref="modal">
        <template slot="title">
            {{ t("forms-appearance-title") }}
        </template>
        <template slot="body">
            <p class="appearance-hint">{{ t("forms-appearance-subtitle") }}</p>

            <div class="appearance-field">
                <label for="client-fields-position">
                    {{ t("forms-appearance-position_label") }}
                </label>
                <kv-select
                    id="client-fields-position"
                    size="small"
                    variant="outlined"
                    full-width
                    :options="positionOptions"
                    v-model="settings.client_fields_position"
                />
            </div>

            <div class="appearance-field">
                <kv-input
                    id="success-title"
                    size="small"
                    variant="outlined"
                    :label="t('forms-appearance-success_title_label')"
                    :placeholder="t('forms-appearance-success_title_placeholder')"
                    v-model="settings.success_title"
                />
            </div>

            <div class="appearance-field">
                <kv-textarea
                    id="success-message"
                    size="small"
                    variant="outlined"
                    :rows="4"
                    resize
                    :label="t('forms-appearance-success_message_label')"
                    :placeholder="t('forms-appearance-success_message_placeholder')"
                    v-model="settings.success_message"
                />
            </div>
        </template>
        <template slot="footer">
            <kv-button
                variant="filled"
                prepend-icon="ui-save-01"
                :disabled="!modified"
                :loading="saving"
                @click="save"
            >
                {{ t("forms-appearance-btn_save") }}
            </kv-button>
        </template>
    </modal>
</template>

<script>
import keviApi from "../keviApi";
import KvButton from "../components/form/kv-button.vue";
import KvSelect from "../components/inputs/kv-select.vue";
import KvInput from "../components/inputs/kv-input.vue";
import KvTextarea from "../components/inputs/kv-textarea.vue";

const emptySettings = function () {
    return {
        client_fields_position: "below",
        success_title: "",
        success_message: "",
    };
};

export default {
    name: "form-appearance-drawer",
    props: {
        form: {
            type: Object,
            default: null,
        },
        formsId: {
            type: [String, Number],
            required: true,
        },
    },
    components: {
        "kv-button": KvButton,
        "kv-select": KvSelect,
        "kv-input": KvInput,
        "kv-textarea": KvTextarea,
    },
    data: function () {
        return {
            settings: emptySettings(),
            settingsDefault: emptySettings(),
            saving: false,
        };
    },
    computed: {
        modified() {
            return (
                JSON.stringify(this.settings) !==
                JSON.stringify(this.settingsDefault)
            );
        },
        positionOptions() {
            return [
                {
                    value: "below",
                    label: this.t("forms-appearance-position_below"),
                },
                {
                    value: "above",
                    label: this.t("forms-appearance-position_above"),
                },
            ];
        },
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        open() {
            this.loadFromForm(this.form);
            this.$refs.modal.open();
        },
        loadFromForm(form) {
            const settings = {
                client_fields_position:
                    (form && form.client_fields_position) || "below",
                success_title: (form && form.success_title) || "",
                success_message: (form && form.success_message) || "",
            };
            this.settings = settings;
            this.settingsDefault = JSON.parse(JSON.stringify(settings));
        },
        save() {
            this.saving = true;
            const options = keviApi.getOptions(
                `form/${this.formsId}/settings`,
                "POST",
                {
                    client_fields_position: this.settings.client_fields_position,
                    success_title: this.settings.success_title,
                    success_message: this.settings.success_message,
                },
            );
            this.$http(options).then(
                function (response) {
                    this.saving = false;
                    if (response.status === 200) {
                        this.settingsDefault = JSON.parse(
                            JSON.stringify(this.settings),
                        );
                        this.$store.dispatch(
                            "notification/success",
                            this.t("forms-appearance-notification_saved"),
                        );
                        const savedForm =
                            response.body && response.body.form
                                ? response.body.form
                                : this.settings;
                        this.$emit("saved", savedForm);
                        this.$refs.modal.close();
                    }
                },
                () => {
                    this.saving = false;
                },
            );
        },
    },
};
</script>

<style scoped lang="less">
.appearance-hint {
    margin: 0 0 16px;
    font-size: 13px;
    color: #6c737f;
}

.appearance-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 16px;

    label {
        margin: 0;
        font-size: 12px;
        color: #1f2a37;
    }
}

</style>
